import { eplAccessTech } from "../types/index.const";

const eplAccessTechOptions = eplAccessTech.map((el) => ({
  value: el,
  label: el,
}));
export default eplAccessTechOptions;
